export const parseJwt = (token) => {
  if (!token) return;
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace('-', '+').replace('_', '/');
  return JSON.parse(typeof window === 'undefined' ? Buffer.from(base64, 'base64').toString() : window.atob(base64));
};
